import { render, staticRenderFns } from "./MRVODFUR.vue?vue&type=template&id=676103f4&scoped=true"
import script from "./MRVODFUR.vue?vue&type=script&lang=js"
export * from "./MRVODFUR.vue?vue&type=script&lang=js"
import style0 from "./MRVODFUR.vue?vue&type=style&index=0&id=676103f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676103f4",
  null
  
)

export default component.exports